import { render, staticRenderFns } from "./BloodTypeAdd.vue?vue&type=template&id=4356187e&scoped=true&"
import script from "./BloodTypeAdd.vue?vue&type=script&lang=js&"
export * from "./BloodTypeAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4356187e",
  null
  
)

export default component.exports